import React from "react";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";

export default function Videobroadcast() {
  return (
    <section className="licenses antiCorruption development videobroadcast">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title dissertation__title">
        Видеотрансляции
      </h1>

      <h4 className="dissertation__caption">
        Ссылка на трансляцию заседания диссертационного совета 72.1.018.01,
        начало заседания — 13.03.2026 г., 11:00
      </h4>

      <a
        href="https://telemost.yandex.ru/j/38131591048104"
        target="_blank"
        rel="noopener noreferrer"
        class="structure__download-link licenses__link"
      >
        https://telemost.yandex.ru/j/38131591048104
      </a>
    </section>
  );
}
